export var regularPaymentMap = {};
export var quickPaymentMap = {};
export var resendMap = {};